// removed by extract-text-webpack-plugin
module.exports = {"ladda-button":"ladda-button","ladda-spinner":"ladda-spinner","ladda-label":"ladda-label","ladda-progress":"ladda-progress"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ladda/dist/ladda-themeless.min.css
// module id = ./node_modules/ladda/dist/ladda-themeless.min.css
// module chunks = 0